/**
 * Created by jiameiwu on 25/09/2018.
 */
import {autoserialize} from 'cerialize';

export class DataFieldDataTypeEnumerationModel {
    @autoserialize public items: string[];
    @autoserialize public multiSelect: boolean;
}
